import React from 'react';
import { IonSplitPane, IonMenu } from '@ionic/react';
import { Sidebar } from '../Dashboard/Navigation/Sidebar';
import styles from './Dashboard.module.css';

interface DashboardLayoutProps {
  children?: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <IonSplitPane contentId="main-content" when="md">
      <IonMenu 
        contentId="main-content" 
        className={styles.sidebarContainer}
      >
        <Sidebar />
      </IonMenu>

      <main id="main-content" className={styles.mainContent}>
        {children}
      </main>
    </IonSplitPane>
  );
};

export default DashboardLayout; 